export enum Locale {
  ENGLISH = 'en',
  ENGLISH_CANADA = 'en-CA',
  ENGLISH_AUSTRALIA = 'en-AU',
  ENGLISH_IRELAND = 'en-IE',
  ENGLISH_NEW_ZEALAND = 'en-NZ',
  GERMAN = 'de',
  FRENCH_CANADA = 'fr-CA',
  FRENCH_SWITZERLAND = 'fr-CH',
  NORWEGIAN = 'no',
  ESTONIA = 'et-EE',
  FINLAND = 'fi',
}

export const isFrenchLocale = (locale: string): boolean =>
  [Locale.FRENCH_CANADA, Locale.FRENCH_SWITZERLAND].includes(locale as Locale);

export const MAP_LOCALE_TO_ISO: Record<string, string> = {
  [Locale.ESTONIA]: 'et',
  [Locale.FRENCH_CANADA]: 'fr',
  [Locale.GERMAN]: 'de',
};

export const countryTitle: Record<Locale, string> = {
  [Locale.ENGLISH_AUSTRALIA]: 'Australia',
  [Locale.ENGLISH]: 'England',
  [Locale.ENGLISH_CANADA]: 'Canada',
  [Locale.GERMAN]: 'Deutschland',
  [Locale.ENGLISH_IRELAND]: 'Ireland',
  [Locale.ENGLISH_NEW_ZEALAND]: 'New Zealand',
  [Locale.FRENCH_CANADA]: 'Canada',
  [Locale.FRENCH_SWITZERLAND]: 'Switzerland',
  [Locale.NORWEGIAN]: 'Norway',
  [Locale.ESTONIA]: 'Estonia',
  [Locale.FINLAND]: 'Finlad',
};

export const localStringLocalesMap: Record<string, string> = {
  [Locale.GERMAN]: 'de-AT',
  [Locale.FRENCH_CANADA]: 'en',
};

export const UNSUPPORTED_LOCALES = new Set<string>([
  Locale.FINLAND,
  Locale.ESTONIA,
]);
